export { default } from './TabScrollButton';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/TabScrollButton/index.js
// module id = 414
// module chunks = 2